module.exports = __webpack_public_path__ + "img/logo.814a8a5b.png";